import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const UndoIcon = withSvgIcon(
    <g>
        <path d="M174.2 117.4l-.3 34.6-.2 25.1 25-2s6-.4 16-.4c15.8 0 40.4 1.1 68.3 6.3 32.9 6.1 61.9 16.4 86.1 30.5 15.2 8.9 30.3 25.5 44.7 49.4 12.4 20.5 24.1 46.1 34.8 75.9.9 2.6 1.9 5.2 2.8 7.8-48.6-52-124.1-63-179.5-63-45.6 0-80.4 7.3-81.8 7.6l-18.2 3.9v56.1L35.7 234.9l138.5-117.5m23.4-50L0 235l194.9 163.6v-86.8s33.3-7.1 77-7.1c53.7 0 123 10.7 165.3 58.6 53.2 60.2 62.2 69.5 62.8 69.5.2 0-1.2-1.8-1.2-1.8s-36.7-192-118.1-239.5c-60.8-35.4-133.1-39.9-166-39.9-11.2 0-17.8.5-17.8.5l.7-84.7z" />
    </g>
);
